import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Icon } from "@qgiv/core-react";
import { Divider } from "@qgiv/core-donor";
import "./ReceiptParticipant.scss";

const ReceiptParticipant = ({
    categoryName = "",
    commitmentSummaryLabel = "",
    email = "",
    firstName = "",
    hasCommitment = false,
    id = "",
    lastName = "",
    participantTotal = "",
    teamCaptain = 0,
    teamName = "",
    registrationLabel,
    nfp,
    nonFundraisingParticipantLabel,
    teamCaptainLabel,
    hasPromo = false,
    formattedPrePromoPrice = "",
    isMultiCategory = false,
    isManagedByPrimary = false,
    managedAdditionalParticipantLabel,
}) => {
    let commitmentLabel;
    if (hasCommitment) {
        commitmentLabel = (
            <>
                <Icon
                    className="-margin-right--5"
                    glyph="bullseye-arrow-regular"
                    type="FontAwesome"
                />
                {commitmentSummaryLabel}
            </>
        );
    }
    return (
        <div className="col col--12 col--no-top-gutter">
            <div className="grid">
                <div className="col col--8">
                    <p className="participant-details">
                        {firstName} {lastName}
                        {categoryName && isMultiCategory && (
                            <>
                                <br />
                                <span className="-type--small">
                                    {categoryName}
                                </span>
                            </>
                        )}
                        {teamName && (
                            <>
                                <br />
                                <span className="-type--small">{teamName}</span>
                                {teamCaptain === 1 && (
                                    <span className="-type--small">
                                        {" • "}
                                        <Icon
                                            className="participant-details__icon"
                                            glyph="crown-regular"
                                            type="FontAwesome"
                                        />
                                        {teamCaptainLabel}
                                    </span>
                                )}
                            </>
                        )}
                        {email && (
                            <>
                                <br />
                                <span className="-type--small">{email}</span>
                            </>
                        )}
                        {nfp && (
                            <>
                                <br />
                                <span className="-type--small">
                                    <Icon
                                        className="participant-details__icon"
                                        glyph="exclamation-circle-solid"
                                        type="FontAwesome"
                                    />
                                    {nonFundraisingParticipantLabel}
                                </span>
                            </>
                        )}
                        {/* Commitment Details */}
                        {hasCommitment && (
                            <>
                                <br />
                                <span className="-type--small">
                                    {commitmentLabel}
                                </span>
                            </>
                        )}
                        {isManagedByPrimary && (
                            <>
                                <br />
                                <span className="-type--small">
                                    <Icon
                                        className="participant-details__icon"
                                        glyph="exclamation-circle-solid"
                                        type="FontAwesome"
                                    />
                                    {managedAdditionalParticipantLabel}
                                </span>
                            </>
                        )}
                        {id && (
                            <>
                                <br />
                                <span className="-type--small">
                                    {registrationLabel}
                                </span>
                            </>
                        )}
                    </p>
                </div>
                <div className="col col--4 -text--right">
                    <p>
                        {hasPromo && (
                            <span
                                className={cx(
                                    hasPromo &&
                                        "-text-decoration--line-through",
                                )}
                            >
                                {formattedPrePromoPrice}
                            </span>
                        )}
                        <span
                            className={cx(
                                hasPromo &&
                                    "-color--system-error -padding-left--5 -font-weight--bold",
                            )}
                        >
                            {participantTotal}
                        </span>
                    </p>
                </div>
            </div>
            <Divider dashed />
        </div>
    );
};

ReceiptParticipant.propTypes = {
    categoryName: PropTypes.string,
    commitmentSummaryLabel: PropTypes.string,
    email: PropTypes.string,
    firstName: PropTypes.string,
    formattedPrePromoPrice: PropTypes.string,
    hasCommitment: PropTypes.bool,
    hasPromo: PropTypes.bool,
    id: PropTypes.number,
    isMultiCategory: PropTypes.bool,
    isManagedByPrimary: PropTypes.bool,
    lastName: PropTypes.string,
    managedAdditionalParticipantLabel: PropTypes.string.isRequired,
    nfp: PropTypes.bool.isRequired,
    nonFundraisingParticipantLabel: PropTypes.string.isRequired,
    participantTotal: PropTypes.string,
    registrationLabel: PropTypes.string.isRequired,
    teamCaptain: PropTypes.number,
    teamName: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    teamCaptainLabel: PropTypes.string.isRequired,
};

export default ReceiptParticipant;
